const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

// NOTE: APIレスポンスはHTML文字列や配列など想定外の形で返る可能性があるため、オブジェクトかつdataを持つ場合のみ取り出す
export const extractUserDetailData = <T>(items: unknown): T | null =>
  isPlainObject(items) && items.data ? (items.data as T) : null;

// NOTE: typeof だけでは null と配列が object になり区別できないため、個別に判定する
const typeOf = (value: unknown): string => {
  if (value === null) return "null";
  if (Array.isArray(value)) return "array";

  return typeof value;
};

// NOTE: レスポンス内容全体は個人情報を含むため通知せず、追跡に必要な情報のみ記録する
export const buildMissingUserDetailDataError = (fetchUrl: string, items: unknown): Error => {
  const detail = isPlainObject(items)
    ? `keys: [${Object.keys(items).join(",")}]`
    : `type: ${typeOf(items)}`;

  return new Error(
    `スカウト求職者詳細APIのレスポンスにdataが存在しません (url: ${fetchUrl}, ${detail})`,
  );
};
